import Image from 'next/image';
import { IMAGE_BY_MIME_TYPE, MimeType } from './constants';

const UNKNOWN_IMAGE_URL = '/file-types/thumbnail-other.svg';

type AssetLibraryAssetTypeImageProps = {
    height?: number;
    mimeType?: MimeType;
    width?: number;
};

export const AssetLibraryAssetTypeImage = ({
    height,
    mimeType,
    width,
}: AssetLibraryAssetTypeImageProps): JSX.Element => {
    const imageUrl = IMAGE_BY_MIME_TYPE[mimeType ?? MimeType.Unknown] ?? UNKNOWN_IMAGE_URL;
    return <Image alt={mimeType ?? 'unknown'} height={height} src={imageUrl} width={width} />;
};

AssetLibraryAssetTypeImage.displayName = 'AssetLibraryAssetTypeImage';
